import {
  Alert,
  Box,
  Button,
  LinearProgress,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { Transition } from "../../pages/app/utils/animation";
import { useUploadQueue } from "../../store/uploadQueue/hooks";
import { useSnackbars } from "../../store/snackbars/hooks";

export const UploadingSnackbar = () => {
  const {
    clipId,
    description,
    isUploading,
    overallProgress,
    reset: uploadQueueReset,
    cancelCurrentUpload: uploadQueueCancelCurrentUpload,
  } = useUploadQueue();
  const { showUploadingSnackbar, closeUploadingSnackbar } = useSnackbars();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={isUploading && showUploadingSnackbar}
      onClose={() => closeUploadingSnackbar()}
      slots={{
        transition: Transition,
      }}
      slotProps={{
        clickAwayListener: {
          mouseEvent: false,
          touchEvent: false,
        },
      }}
    >
      <Alert
        onClose={() => closeUploadingSnackbar()}
        icon={false}
        severity="info"
        variant="outlined"
        sx={{
          bgcolor: "background.paper",
          "& .MuiAlert-action": { pl: 0 },
          boxShadow: 3,
        }}
      >
        <Stack gap={1}>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                textTransform: "uppercase",
              }}
            >
              Importing:
            </Typography>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 150,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {description}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Box mr={1} width={200}>
              <LinearProgress variant="determinate" value={overallProgress} />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              minWidth={35}
            >
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {`${overallProgress}%`}
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            size="small"
            onClick={async () => {
              await uploadQueueCancelCurrentUpload();
              await uploadQueueReset(clipId);
              closeUploadingSnackbar();
            }}
          >
            Cancel Import
          </Button>
        </Stack>
      </Alert>
    </Snackbar>
  );
};
